const buttonStyle = {
    icon: {
        padding: 0,
        width: 22,
        height: 22,
        marginBottom: 11
    },
    icon_space: {
        padding: 0,
        width: 22,
        height: 22,
        marginBottom: 11,
        marginLeft: 10
    },
    iconVideo: {
        minWidth: 22,
        lineHeight: '22px',
        height: 23,
        margin: '3px 0 4px 11px'
    },
    smallIcon: {
        padding: 0,
        width: 22,
        height: 22
    }
};

export default buttonStyle;


// WEBPACK FOOTER //
// src/components/ui/button.js